import React, { useCallback, useMemo, useState } from 'react';
import { Description, Link, SubTitle, Image } from '../../components/layouts';
import { buildImageURL, getTrack } from '../../helpers';
import './style.scss';
import LazyLoad from 'react-lazyload';


const isWebp = document.querySelector('html').classList.contains('webpSupport');

const LIST1_D = [
  isWebp ? buildImageURL("/appearance-all-1.webp") : buildImageURL("/appearance-all-1.jpg"),
  isWebp ? buildImageURL("/appearance-orange-1.webp") : buildImageURL("/appearance-orange-1.png"),
  isWebp ? buildImageURL("/appearance-gray-1.webp") : buildImageURL("/appearance-gray-1.png"),
];
const LIST2_D = [
  isWebp ? buildImageURL("/appearance-all-2.webp") : buildImageURL("/appearance-all-2.png"),
  isWebp ? buildImageURL("/appearance-orange-2.webp") : buildImageURL("/appearance-orange-2.png"),
  isWebp ? buildImageURL("/appearance-gray-2.webp") : buildImageURL("/appearance-gray-2.png"),
];
const LIST3_D = [
  isWebp ? buildImageURL("/appearance-all-3.webp") : buildImageURL("/appearance-all-3.png"),
  isWebp ? buildImageURL("/appearance-orange-3.webp") : buildImageURL("/appearance-orange-3.png"),
  isWebp ? buildImageURL("/appearance-gray-3.webp") : buildImageURL("/appearance-gray-3.png"),
];
const LIST1_M = [
  isWebp ? buildImageURL("/appearance-all-m-1.webp") : buildImageURL("/appearance-all-m-1.jpg"),
  isWebp ? buildImageURL("/appearance-orange-m-1.webp") : buildImageURL("/appearance-orange-m-1.png"),
  isWebp ? buildImageURL("/appearance-gray-m-1.webp") : buildImageURL("/appearance-gray-m-1.png"),
];
const LIST2_M = [
  isWebp ? buildImageURL("/appearance-all-m-2.webp") : buildImageURL("/appearance-all-m-2.png"),
  isWebp ? buildImageURL("/appearance-orange-m-2.webp") : buildImageURL("/appearance-orange-m-2.png"),
  isWebp ? buildImageURL("/appearance-gray-m-2.webp") : buildImageURL("/appearance-gray-m-2.png"),
];
const LIST3_M = [
  isWebp ? buildImageURL("/appearance-all-m-3.webp") : buildImageURL("/appearance-all-m-3.png"),
  isWebp ? buildImageURL("/appearance-orange-m-3.webp") : buildImageURL("/appearance-orange-m-3.png"),
  isWebp ? buildImageURL("/appearance-gray-m-3.webp") : buildImageURL("/appearance-gray-m-3.png"),
];

const track = getTrack({ block: 2 });

export function Appearance({mobile = false}) {

  const LIST1 = mobile ? LIST1_M : LIST1_D;
  const LIST2 = mobile ? LIST2_M : LIST2_D;
  const LIST3 = mobile ? LIST3_M : LIST3_D;

  const [index, setIndex] = useState(0);
  const [hoverIndex, setHoverIndex] = useState(-1);

  const updateIndex = (index) => {
    setIndex(index);
  }

  return (
    <div className="page-section section-appearance inverted" data-track={track}>
      <div className="section-content center">
        <div className="txt-title">
          <SubTitle>
            第一眼，就大饱眼福
          </SubTitle>
          <Description>
            惊艳始于颜值，终于设计。前后 3D 曲面设计，高质感配
            <br/>
            色，开启审美新秩序。
          </Description>
        </div>
          <div className="box1">
            {/*<div className="desktop-img-wrapper" style={{width: `${LIST1.length * 100}%`, transform: `translateX(-${index * 100 / LIST1.length}%)`}} >*/}
            {/*  {LIST1.map((item, index) => <Image key={index} src={item}/>)}*/}
            {/*</div>*/}
            <LazyLoad><Image src={LIST1[0]}/></LazyLoad>
          </div>
        <div className="pic-box" >
          <div className="box2">
            <div className="box-item box21">
              <div className="img-wrapper" style={{width: `${LIST2.length * 100}%`, transform: `translateX(-${index * 100 / LIST2.length}%)`}} >
                {LIST2.map((item, index) => <LazyLoad><Image key={index} src={item}/></LazyLoad>)}
              </div>
            </div>
            <div className="box-item box22">
              <div className="img-wrapper" style={{width: `${LIST3.length * 100}%`, transform: `translateX(-${index * 100 / LIST3.length}%)`}} >
                {LIST3.map((item, index) => <LazyLoad><Image key={index} src={item}/></LazyLoad>)}
              </div>
            </div>
          </div>

          <div className="dot-box">
            <div>
              <div className={`dot dot1 ${index === 0 ? "active" : ""} ${hoverIndex === 0 ? "active" : ""}`}
                   onClick={() => updateIndex(0)}
                   onMouseEnter={() => setHoverIndex(0)}
                   onMouseLeave={() => setHoverIndex(-1)} >
              </div>
              <Description style={{opacity: `${index === 0 ? 1 : 0}`}} >全色系</Description>
            </div>

            <div>
              <div className={`dot dot2 ${index === 1 ? "active" : ""} ${hoverIndex === 1 ? "active" : ""}`}
                   onClick={() => updateIndex(1)}
                   onMouseEnter={() => setHoverIndex(1)}
                   onMouseLeave={() => setHoverIndex(-1)} >
              </div>
              <Description style={{opacity: `${index === 1 ? 1 : 0}`}} >橙色</Description>
            </div>

            <div>
              <div className={`dot dot3 ${index === 2 ? "active" : ""} ${hoverIndex === 2 ? "active" : ""}`}
                   onClick={() => updateIndex(2)}
                   onMouseEnter={() => setHoverIndex(2)}
                   onMouseLeave={() => setHoverIndex(-1)} >
              </div>
              <Description style={{opacity: `${index === 2 ? 1 : 0}`}} >灰色</Description>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
